/**
 * Opens an external URL in the appropriate browser context
 * Handles iOS webview, Android webview, and web browsers
 */
export const openExternalURL = (url: string): void => {
  // Check for iOS webview native bridge
  if ((window as any).webkit?.messageHandlers?.openExternalURL) {
    (window as any).webkit.messageHandlers.openExternalURL.postMessage(url);
    return;
  }

  // Check for Android webview native bridge
  if ((window as any).android?.openExternalURL) {
    (window as any).android.openExternalURL(url);
    return;
  }

  // Fallback for web browsers
  window.open(url, "_blank");
};

/**
 * Checks if the app is running in a native webview
 */
export const isNativeWebview = (): boolean => {
  return !!((window as any).webkit?.messageHandlers || (window as any).android);
};
